// extracted by mini-css-extract-plugin
module.exports = {"logoList":"logoList-module--logoList--3kyQK"};